import { createContext, useContext } from 'react'

import { chain } from 'lodash'
import { DateTime } from 'luxon'

export const SlotsByHourContext = createContext()

export const SlotsByHourProvider = ({ slots, children }) => {
  const groupedSlots = chain(slots)
    .groupBy(({ start_time: startTime }) => DateTime.fromJSDate(startTime).startOf('hour').toISO())
    .value()

  return (
    <SlotsByHourContext.Provider value={{ slots: slots, groupedSlots }}>
      {children}
    </SlotsByHourContext.Provider>
  )
}

export const withSlotsByHour =
  (Component) =>
  ({ options, ...props }) => (
    <SlotsByHourProvider slots={options}>
      <Component {...props} />
    </SlotsByHourProvider>
  )

export const useSlotsByHourContext = () => useContext(SlotsByHourContext)

export const AppointmentSlotForm = createContext()

export const AppointmentSlotFormProvider = ({
  onTimeChange,
  onPractitionerIdsChange,
  onRoomIdChange,
  onEquipmentIdsChange,
  onPriceChange,
  time,
  practitionerIds,
  numPractitioners = 1,
  roomId,
  equipmentIds,
  children,
}) => {
  return (
    <AppointmentSlotForm.Provider
      value={{
        time,
        practitionerIds,
        roomId,
        equipmentIds,
        numPractitioners,
        onTimeChange,
        onPractitionerIdsChange,
        onRoomIdChange,
        onEquipmentIdsChange,
        onPriceChange,
      }}
    >
      {children}
    </AppointmentSlotForm.Provider>
  )
}

export const withAppointmentSlotForm =
  (Component) =>
  ({
    onTimeChange,
    onPractitionerIdsChange,
    onRoomIdChange,
    onEquipmentIdsChange,
    onPriceChange,
    time,
    practitionerIds,
    numPractitioners,
    roomId,
    equipmentIds,
    ...props
  }) => (
    <AppointmentSlotFormProvider
      onTimeChange={onTimeChange}
      onPractitionerIdsChange={onPractitionerIdsChange}
      onRoomIdChange={onRoomIdChange}
      onEquipmentIdsChange={onEquipmentIdsChange}
      onPriceChange={onPriceChange}
      time={time}
      practitionerIds={practitionerIds}
      numPractitioners={numPractitioners}
      roomId={roomId}
      equipmentIds={equipmentIds}
    >
      <Component {...props} />
    </AppointmentSlotFormProvider>
  )

export const useAppointmentForm = () => useContext(AppointmentSlotForm)
